import { substatusType } from '../types/vulnerability-substatus-alias'
import { SubstatusName } from '../../../components/vulnerability-status/status'
import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'

export interface UpdateVulnerabilitySubstatusAliasArgs {
  readonly input: {
    readonly organizationUuid: string
    readonly substatus: SubstatusName
    readonly label: string
  }
}

const updateVulnerabilitySubstatusAliasArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'UpdateVulnerabilitySubstatusAliasArgs',
      description:
        'Mutation input type for updating a vulnerability substatus alias',
      fields: () => ({
        organizationUuid: {
          description:
            'The UUID of the organization that owns the alias being mutated',
          type: new GraphQLNonNull(GraphQLID)
        },
        substatus: {
          description: 'The substatus that the substatus alias is overriding',
          type: new GraphQLNonNull(substatusType)
        },
        label: {
          description: 'The name of the alias',
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}

export const updateVulnerabilitySubstatusAlias: GraphQLFieldConfig<
  any,
  Context,
  UpdateVulnerabilitySubstatusAliasArgs
> = {
  description: 'Update vulnerability substatus alias',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: updateVulnerabilitySubstatusAliasArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationUuid, substatus, label } = args.input

    await context.connector.put(
      `/organizations/${organizationUuid}/vulnerabilities/substatus`,
      {
        substatus,
        label
      }
    )

    return {
      _placeholder: true
    }
  }
}
